/**
 * Safely parse and decode the 'next' URL parameter from different sources
 */

/**
 * Parse next URL from Next.js router query
 * @param query - Next.js router query object
 * @returns Decoded next URL or null
 */
export const parseNextUrlFromQuery = (query: {
  [key: string]: string | string[] | undefined;
}): string | null => {
  const nextParam = query.next;
  if (typeof nextParam === "string") {
    try {
      return decodeURIComponent(nextParam);
    } catch {
      return nextParam;
    }
  }
  return null;
};

/**
 * Parse next URL from query string (server-side)
 * @param queryString - Query string portion of URL
 * @returns Decoded next URL or null
 */
export const parseNextUrlFromQueryString = (
  queryString: string
): string | null => {
  if (!queryString) return null;

  // Find the next parameter in query string
  const nextMatch = queryString.match(/(?:^|&)next=([^&]*)/);
  if (nextMatch && nextMatch[1]) {
    try {
      return decodeURIComponent(nextMatch[1]);
    } catch {
      return nextMatch[1];
    }
  }
  return null;
};

/**
 * Parse next URL from full URL (server-side)
 * @param url - Full URL string
 * @returns Decoded next URL or null
 */
export const parseNextUrlFromUrl = (url: string): string | null => {
  const queryString = url.split("?")[1];
  return parseNextUrlFromQueryString(queryString);
};
